import { createIcon } from '@chakra-ui/react';

export const CreditCardWhiteIcon = createIcon({
  displayName: 'CreditCardWhiteIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <path
          d="M11 3.77501C11 4.10501 10.73 4.37501 10.4 4.37501H1.6C1.27 4.37501 1 4.10501 1 3.77501V3.77001C1 2.62501 1.925 1.70001 3.07 1.70001H8.925C10.07 1.70001 11 2.63001 11 3.77501Z"
          fill="white"
        />
        <path
          d="M1 5.725V8.23C1 9.375 1.925 10.3 3.07 10.3H8.925C10.07 10.3 11 9.37 11 8.225V5.725C11 5.395 10.73 5.125 10.4 5.125H1.6C1.27 5.125 1 5.395 1 5.725ZM4 8.625H3C2.795 8.625 2.625 8.455 2.625 8.25C2.625 8.045 2.795 7.875 3 7.875H4C4.205 7.875 4.375 8.045 4.375 8.25C4.375 8.455 4.205 8.625 4 8.625ZM7.25 8.625H5.25C5.045 8.625 4.875 8.455 4.875 8.25C4.875 8.045 5.045 7.875 5.25 7.875H7.25C7.455 7.875 7.625 8.045 7.625 8.25C7.625 8.455 7.455 8.625 7.25 8.625Z"
          fill="white"
        />
      </svg>
    </>
  ),
});
